module.exports = __WEBPACK_EXTERNAL_MODULE_53__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 53
// module chunks = 0